export default {
    parts: {
        dimensions: {
            width: 'Breite',
            height: 'Höhe'
        }
    },
    report: {
        checks: {
            doorAreas: {
                1: {
                    top: '5%',
                    left: '37%'
                },
                2: {
                    top: '25%',
                    left: '37%'
                },
                3: {
                    top: '65%',
                    left: '65%'
                },
                4: {
                    top: '52%',
                    left: '12%'
                },
                5: {
                    top: '37%',
                    left: '3%'
                },
                6: {
                    top: '90%',
                    left: '10%',
                    icon: 'bolt.svg',
                    iconWidth: '15px'
                },
                7: {
                    top: '93%',
                    left: '35%',
                    icon: 'fire.svg',
                    iconWidth: '20px'
                },
                8: {
                    top: '96%',
                    left: '60%',
                    icon: 'more-option.svg',
                    iconWidth: '40px'
                },
            },
            operationIcons: {
                1: 'settings.svg',
                2: 'eye.svg',
                3: 'eye-dropper.svg',
                4: 'screwdriver.svg'
            }
        }
    }
};